import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { MobileHeaderCard } from '~/components/MobileHeaderCard';
import { orderStore, userStore } from '~/stores';
import capitalize from '~/utils/capitalize';

interface HeaderExpressProps {
  className?: string;
  onClick?: () => void;
}

const HeaderExpress = ({ className, onClick }: HeaderExpressProps) => {
  const { t } = useTranslation();
  const expressTime = orderStore.etaCalculation?.duration?.range ?? '60-90';

  const title = (() => {
    if (!userStore.deliveryAddress) {
      return t('express');
    }

    return userStore.deliveryAddress.type
      ? capitalize(userStore.deliveryAddress.type)
      : userStore.deliveryAddress.shortAddress;
  })();

  return (
    <MobileHeaderCard
      observerKey="header.express"
      icon="flash-3.1"
      animateIcon
      backgroundVariant="express"
      caption={t('phrases:inMinutes', { time: expressTime })}
      title={title}
      onClick={onClick}
      className={className}
    />
  );
};

export default observer(HeaderExpress);
